import HeroWrapper from "./HeroWrapper";
import React, {useEffect} from "react";
import Aos from "aos";

const Hero = ({ heroInformation, socialMedias }) => {
    
    useEffect(() => {
        Aos.init({
            duration: 1500, once: true
        })
    })
    
    return(
        <section data-aos="fade-up" id={"hero"}
             data-aos-anchor-placement="center-bottom" 
             className={'relative min-h-screen flex items-center w-full justify-center overflow-hidden bg-slate-50 dark:bg-slate-900 transition-colors duration-300'}>
            
            {/* Subtle Grid Background */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            
            {/* Gentle ambient glow */}
            <div className="absolute left-0 right-0 top-0 -z-10 m-auto h-[310px] w-[310px] rounded-full bg-blue-400 dark:bg-blue-600 opacity-20 blur-[100px]"></div>
            
            <div className="relative z-10 w-full">
                <HeroWrapper heroInformation={heroInformation} socialMedias={socialMedias} />
            </div>
        </section>
    )
}
export default Hero;
